// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--dmrQb";
export var footerImages = "footer-module--footer-images--E4Y50";
export var footerInfo = "footer-module--footer-info--r+j9k";
export var footerLinks = "footer-module--footer-links--waNdB";
export var footerWrapper = "footer-module--footer-wrapper--kTzj+";